export const REASON_MAX_BYTES = 100;

const CUSTOM_ERROR_MESSAGES: Record<string, string> = {
  // BoxBetFactory custom errors
  '0xe57902cd': 'Initial liquidity is below minimum. Use at least 50 tokens (or 50 USDC on default collateral).',
  '0x74003c0a': 'Invalid collateral token address or token metadata is unavailable.',
  '0x97752954': 'Custom collateral must use 18 decimals.',
  '0x33e62cb9': 'Outcome name/symbol is invalid (must be 1-25 characters).',
  '0xd8ac9325': 'Unknown market for this adapter.',
  '0x8945c2d9': 'Market is not resolvable yet.',
  '0x46752361': 'Creator acceptance window elapsed. Early proposals must be accepted before resolve time.',
  '0x475a2535': 'Adapter resolution is already finalized. This market must be settled via market.settleMarket before claim; if this still appears, this market is in a settlement mismatch state.',
  '0x79429186': 'A proposal already exists for this market.',
  '0xc74a206d': 'Selected outcome is invalid.',
  '0x0dc5fde9': 'No proposal exists yet.',
  '0x09dd1236': 'This proposal is already disputed.',
  '0x80e7f40c': 'You cannot dispute your own proposal.',
  '0xe340e58c': 'Dispute window has already elapsed.',
  '0x87920b43': 'Dispute window is still open. Finalization is blocked.',
  '0xde2e8644': 'Emergency ruling is invalid for current state (requires disputed market and valid outcome).',
  '0x3982edeb': 'Only the configured grand judge can submit emergency rulings.',
  '0x1704b038': 'Escalation period is still pending before emergency ruling.',
  '0xa237a365': 'Emergency decision window elapsed.',
  '0x06417a60': 'Invalid market id for this market contract.',
  '0x0d34f119': 'Court case is not open yet. After dispute window closes, click Finalize to open/progress court rounds.',
  '0x3a41b48b': 'Market is not settled yet. Settle first, then claim.',
  '0x2592e3a8': 'Market is already settled.',
  '0x1f2a2005': 'No claimable payout (no winning shares, already claimed, or zero payout).',
  '0xbc7fd331': 'Reason is required for this action.',
  '0x34b4e35e': 'Reason is too long. Maximum is 100 bytes.',
};

export function normalizeReason(raw: string, required: boolean, actionLabel: string): string {
  const value = (raw || '').trim();
  const bytes = new TextEncoder().encode(value).length;
  if (required && bytes === 0) {
    throw new Error(`${actionLabel} reason is required.`);
  }
  if (bytes > REASON_MAX_BYTES) {
    throw new Error(`${actionLabel} reason is too long (${bytes}/${REASON_MAX_BYTES} bytes).`);
  }
  return value;
}

export function extractCustomErrorSelector(error: any): string | null {
  const candidates: unknown[] = [
    error?.data,
    error?.error?.data,
    error?.info?.error?.data,
    error?.revert?.data,
  ];

  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.startsWith('0x') && candidate.length >= 10) {
      return candidate.slice(0, 10).toLowerCase();
    }
  }
  return null;
}

export function friendlyErrorMessage(error: any, fallback: string): string {
  const selector = extractCustomErrorSelector(error);
  if (selector && CUSTOM_ERROR_MESSAGES[selector]) return CUSTOM_ERROR_MESSAGES[selector];
  return error?.shortMessage || error?.message || fallback;
}
